
import superagent from "superagent";
import {authorize, authorize_onboarding} from "../../helper/authorize-token";
import {deep_copy} from "../../../lib/js-utils";

const USER_PAYMENT_SET_LOADING = "USER_PAYMENT_SET_LOADING";
const ADD_USER_PAYMENT_ITEM = "ADD_USER_PAYMENT_ITEM";
const SET_USER_PAYMENT_DATA = "SET_USER_PAYMENT_DATA";
const USER_PAYMENTS_CLEAR = "USER_PAYMENTS_CLEAR";

const sendWithdrawEmail = (
  token, amt_usd, acct_index) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/email/withdrawal-request")
      .send({ amt_usd, acct_index })
      .use(authorize(token))
      .then(resolve);
  })
};

const clearUserPayments = () => {
  return dispatch => {
    dispatch({
      type: USER_PAYMENTS_CLEAR,
    })
  }
}

const addUserPaymentItem = (username, payment_item) => {
  return dispatch => {
    dispatch({
      type: ADD_USER_PAYMENT_ITEM,
      username,
      item: payment_item,
    })
  }
}

const ZERO_STATE = {
  loading: false,
}

const GetPaymentInformation = (username) => {
  return (dispatch, getState) => {
    if (!username) {
      username = getState().user.username;
    }
    dispatch({
      type: USER_PAYMENT_SET_LOADING,
      loading: true,
    })
    dispatch({
      type: SET_USER_PAYMENT_DATA,
      payload: superagent
        .post("/api/dwolla/get-payment-information")
        .use(authorize_onboarding(
          getState().user.token,
          getState().user.onboarding_token))
        .send({ username }),
    })
  }
}

const userPaymentsReducer = (state = ZERO_STATE, action) => {

  let new_state = deep_copy(state);
  let data;
  switch(action.type) {
    case USER_PAYMENTS_CLEAR:
      new_state = ZERO_STATE;
      break;
    case SET_USER_PAYMENT_DATA + "_FULFILLED":
      data = action.payload.body.data;
      const username = deep_copy(data.username);
      delete data.username;
      new_state.loading = false;
      new_state[username] = data;
      break;
    case USER_PAYMENT_SET_LOADING:
      new_state.loading = action.loading;
      break;
    case ADD_USER_PAYMENT_ITEM:
      if (action.username in new_state) {
        data = new_state[action.username];
      } else {
        new_state[action.username] = {
          current_payments: [],
          past_payments: [],
        };
        data = new_state[action.username];
      }
      data.current_payments.push(action.item);
      break;
    default:
  }
  return new_state;
}

export {
  sendWithdrawEmail, userPaymentsReducer, GetPaymentInformation,
  addUserPaymentItem, clearUserPayments };
